'use client'

import AudienceFit from '@/components/platform/v2/AudienceFit'

const SolutionsPageComponent = () => {
    return (
        <div className="vcentre-public pt-24 sm:pt-28 md:pt-32">
            <AudienceFit />
        </div>
    )
}

export default SolutionsPageComponent
